/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordValidationRuleset } from './PasswordValidationRuleset';
import {
    PasswordValidationRulesetFromJSON,
    PasswordValidationRulesetFromJSONTyped,
    PasswordValidationRulesetToJSON,
    PasswordValidationRulesetToJSONTyped,
} from './PasswordValidationRuleset';

/**
 * 
 * @export
 * @interface PasswordSetChallengeOptions
 */
export interface PasswordSetChallengeOptions {
    /**
     * 
     * @type {PasswordValidationRuleset}
     * @memberof PasswordSetChallengeOptions
     */
    validation_rules: PasswordValidationRuleset;
}

/**
 * Check if a given object implements the PasswordSetChallengeOptions interface.
 */
export function instanceOfPasswordSetChallengeOptions(value: object): value is PasswordSetChallengeOptions {
    if (!('validation_rules' in value) || value['validation_rules'] === undefined) return false;
    return true;
}

export function PasswordSetChallengeOptionsFromJSON(json: any): PasswordSetChallengeOptions {
    return PasswordSetChallengeOptionsFromJSONTyped(json, false);
}

export function PasswordSetChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetFromJSON(json['validation_rules']),
    };
}

export function PasswordSetChallengeOptionsToJSON(json: any): PasswordSetChallengeOptions {
    return PasswordSetChallengeOptionsToJSONTyped(json, false);
}

export function PasswordSetChallengeOptionsToJSONTyped(value?: PasswordSetChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validation_rules': PasswordValidationRulesetToJSON(value['validation_rules']),
    };
}

